import { axiosInstance, live_instance } from "../instance";


/**======================================== 服务器参数配置 ========================================================= */
/** 获取服务器配置列表 */
export const getServerListApi = () => live_instance({method: 'get', url: `/live/api/web/server/groups`})

/**新增服务器配置 */
export const addServerListApi = (params) => live_instance({method: 'post', url: `/live/api/web/server/group`, params})

/** 删除服务器组配置 */
export const deleteServerGroupApi = (id) => live_instance({method: 'delete', url: `/live/api/web/server/group/${id}`})

/** 删除单个服务器配置 */
export const deleteSingleServerApi = (id) => live_instance({method: 'delete', url: `/live/api/web/server/status/${id}`})

/** 新增服务器状态 */
export const addServerStatusApi = (params) => live_instance({method: 'post', url: `/live/api/web/server/status`, params})

/** 更新服务器状态*/
export const updateServerStatusApi = (id,params) => live_instance({method: 'put', url: `/live/api/web/server/status/${id}`, params})

/** 更新服务器配置 */
export const updateServerApi = (id,params) => live_instance({method: 'put', url: `/live/api/web/server/group/${id}`, params})

/**==========================================================主备服务器============================================================== */
/** 获取主备服务器列表 */
export const getMasterSlaveServerListApi = () => live_instance({method: 'get', url: `/live-operation/server-standby/list`})

/** 新增主备服务器 */
export const addMasterSlaveServerApi = (data) => live_instance({method: 'post', url: `/live-operation/server-standby`, data, type:'json'})

/** 删除主备服务器 */
export const deleteMasterSlaveServerApi = (id) => live_instance({method: 'delete', url: `/live-operation/server-standby/${id}`})

/** 更新主备服务器 */
export const updateMasterSlaveServerApi = (data) => live_instance({method: 'put', url: `/live-operation/server-standby`, data, type:'json'})
